import FootballIcon from '@/assets/icons/footballIcon';
import { Text } from '@/components/TextComponent';
import { Column, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { Event } from '@/feature/event-details-sbk/types';
import { useFootballPossession, useTeamScore } from '@/hooks/use-sbk-event-details-cache';

import { TeamLogo } from './TeamLogo';

export const TEAM_ROW_HEIGHT = 62;

type TeamInfoRowProps = {
    event: Event;
    shouldShowFallbackLogo: boolean;
    side: 'home' | 'away';
    teamName: string;
    logoUrl: string;
    primaryColor: string;
    secondaryColor: string;
    isLive: boolean;
    hasFootballIcon?: boolean;
    score?: number;
};

export const TeamInfoRow = ({
    event,
    side,
    hasFootballIcon = false,
    shouldShowFallbackLogo,
    teamName,
    logoUrl,
    primaryColor,
    secondaryColor,
    isLive,
    score,
}: TeamInfoRowProps) => {
    const possession = useFootballPossession(event);
    const shouldShowFootballIcon = hasFootballIcon && possession === side.toUpperCase(); // possession from the API is returned in uppercase as either HOME or AWAY
    const teamScore = useTeamScore(event, side) ?? score;
    return (
        <Row height={TEAM_ROW_HEIGHT} alignItems="center" gap="s8">
            <TeamLogo
                logoUrl={logoUrl}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                shouldShowFallbackLogo={shouldShowFallbackLogo}
            />
            <Row justifyContent="space-between" flex={1} gap="s8">
                <Column flexShrink={1}>
                    <Row gap="s8">
                        <Text variant="titleMedium" color={ds.colorToken.text.primary} numberOfLines={1}>
                            {teamName}
                        </Text>
                        {shouldShowFootballIcon ? (
                            <Row alignItems={'center'}>
                                <FootballIcon />
                            </Row>
                        ) : null}
                    </Row>
                </Column>
                {isLive ? (
                    <Text variant="titleMedium" color={ds.colorToken.text.primary} numberOfLines={1}>
                        {teamScore}
                    </Text>
                ) : null}
            </Row>
        </Row>
    );
};
